// TODO: This will be a catch-all file for utility and helper functions.
// This file should eventually be removed and split into more specific files when there is time.

export const productChoices = (product) => {
	const choices = product.choices.filter(
		(choice) => choice.choice != "quantity"
	);
	return choices;
};

export const getSelectedInventoryItem = (item, choices) => {
	if (!item?.inventory) {
		console.error(
			"No inventory found for product. Cannot determine selected inventory item."
		);
		return null;
	}

	const inventoryItem = item.inventory.inventory.find((tempInventoryItem) =>
		choices.every(
			(choice) => tempInventoryItem.variant[choice.choice] == choice.value
		)
	);

	if (!inventoryItem) {
		console.error(
			"No matching inventory item found for product with choices: ",
			choices,
			"Inventory: ",
			item.inventory.inventory
		);
		return null; // This indicates that there is no available inventory item for the selected choices
	}

	return inventoryItem;
};

export const productQuantityFromChoices = (productChoices) => {
	const quantityChoice = productChoices.find(
		(choice) => choice.choice == "quantity"
	);
	return quantityChoice ? quantityChoice.value : 0;
};

export const choiceValueArrayToObject = (productChoices) => {
	let choicesObject = {};
	productChoices.forEach((choice) => {
		choicesObject[choice.choice] = choice.value;
	});
	return choicesObject;
};

export const haveAllChoicesBeenSelected = (productChoices) => {
	return productChoices.every((choice) => choice.value !== null);
};

export const productTotalsMap = (products) => {
	let totals = new Map();

	products.forEach((product, index, array) => {
		const productChoicesArray = productChoices(product);
		const quantity = productQuantityFromChoices(product.choices);

		if (!haveAllChoicesBeenSelected(productChoicesArray)) {
			return Infinity;
		}

		const inventoryItem = getSelectedInventoryItem(
			product,
			productChoicesArray
		);

		if (!inventoryItem) {
			return Infinity;
		}

		const currency = inventoryItem.currency;
		const price = parseFloat(inventoryItem.price);

		if (!totals.has(currency)) {
			totals.set(currency, 0);
		}
		let updatedTotal =
			//prettier-ignore
			totals.get(currency) + (price * quantity);
		totals.set(currency, updatedTotal);
	});
	return totals;
};

export const totalsMapToPriceString = (priceMap) => {
	let priceString = "";
	priceMap.forEach((value, key, map) => {
		priceString += `${new Intl.NumberFormat("en-US", {
			style: "currency",
			currency: "USD",
		}).format(value)} ${key}  `;
	});

	return priceString;
};

export const productPriceString = (product, choices, quantity = 1) => {
	const productChoicesArray = productChoices(product);
	const inventoryItem = getSelectedInventoryItem(product, productChoicesArray);
	const currency = inventoryItem.currency;
	const price = parseFloat(inventoryItem.price);
	return `${new Intl.NumberFormat("en-US", {
		style: "currency",
		currency: "USD",
	}).format(price * quantity)} ${currency}`;
};

export const formatFloatToMoneyString = (money, currency) => {
	return `${new Intl.NumberFormat("en-US", {
		style: "currency",
		currency: "USD", // 'USD' is the format
	}).format(money)} ${currency}`;
};

export const isHTTPS = () => {
	// Adding for development purposes, since the local dev server is not HTTPS
	if (window.location.hostname === "localhost") {
		return true;
	}

	return window.location.protocol.includes("https");
};

export const extractProductDetailsForCheckout = (product) => {
	return {
		id: product.id,
		choices: productChoices(product),
		quantity: productQuantityFromChoices(product.choices),
	};
};
